import { environment } from '@env/environment';
export class BaseService {

  url(path: string): string {
    const apiPath = `/api`;
    return environment.apiUrl + apiPath + path;
  }

}
